import { CancelToken } from 'axios';
import { BaseApi } from './BaseApi';

export default class Bitly extends BaseApi {
  public async shortenUrlAsync(url: string, cancelToken?: CancelToken) {
    return this.getAsync<string>('bitly/shorten', { url }, cancelToken);
  }
}
